import React, {memo} from "react";
import Label from "components/general/Label"
import useViewport from "components/general/useViewPort";

const TableExpanded = memo((props) => {
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const {row, config} = props;

    const jumpPen = row?.extendedResults?.find(er => er?.er_code === 'J_J_PEN')?.er_value
    const timePen = row?.extendedResults?.find(er => er?.er_code === 'J_T_PEN')?.er_value
    const totPen = row?.extendedResults?.find(er => er?.er_code === 'J_TOTAL_PEN')?.er_value
    const time = row?.extendedResults?.find(er => er?.er_code === 'J_TIME')?.er_value
    const rank = row?.resultRank && row?.resultRankEqual === 'Y' ? '='+row?.resultRank : row?.resultRank;
    const xl = (
        <table className="w-80">
            <thead>
                <tr>
                    <td  className="text-start fw-bold" colSpan={2}><Label data="HeaderPenalties" /></td>
                    <td className="text-end fw-bold"><Label data="HeaderTime" /></td>
                    <td className="text-end fw-bold"><Label data="HeaderRank" /></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-start"><Label data="HeaderJump" /></td>
                    <td className="text-end">{jumpPen}</td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td className="text-start"><Label data="HeaderTime" /></td>
                    <td className="text-end">{timePen}</td>
                    <td className="text-end">{time}</td>
                    <td className="text-end">{rank}</td>
                </tr>
                <tr>
                    <td className="text-start"><Label data="HeaderTotal" /></td>
                    <td className="text-end">{totPen}</td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    );

    const xs = (
        <table className="w-80">
            <thead>
                <tr>
                <td  className="text-start fw-bold" colSpan={2}><Label data="HeaderPenalties" /></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><Label data="HeaderJump" /></td>
                    <td>{jumpPen}</td>
                </tr>
                <tr>
                    <td><Label data="HeaderTime" /></td>
                    <td>{timePen}</td>
                </tr>
                <tr>
                    <td><Label data="HeaderTotal" /></td>
                    <td>{totPen}</td>
                </tr>
            </tbody>
        </table>
    );

    return <>{isMobile ? xs : xl}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    return false;
    //return arraysEqual(prevProps?.res?.extendedResults, nextProps?.res?.extendedResults);
});


export default TableExpanded;
